module.exports = __webpack_public_path__ + "img/xiaomi.196fc106.svg";